import { render } from "./ArtistCardDemogra.vue?vue&type=template&id=fb3809cc&scoped=true"
import script from "./ArtistCardDemogra.vue?vue&type=script&lang=js"
export * from "./ArtistCardDemogra.vue?vue&type=script&lang=js"

import "./ArtistCardDemogra.vue?vue&type=style&index=0&id=fb3809cc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb3809cc"]])

export default __exports__